import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "className", "accentBar", "cornerSize", "style"],
    _excluded2 = ["aspectRatio", "objectFit"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from 'classnames';
import React, { forwardRef } from 'react';
import Default from 'react-bootstrap/Card';
import { Media as _Media } from '../media/media';
import { Body } from '../text/body/body';
import { Description } from '../text/description/description';
import { Title } from '../text/title/title';
import { TabIndicator } from './components/tab-indicator';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var _Card = function _Card(_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      accentBar = _ref.accentBar,
      _ref$cornerSize = _ref.cornerSize,
      cornerSize = _ref$cornerSize === void 0 ? 'md' : _ref$cornerSize,
      style = _ref.style,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs(Default
  /**
   * Surpresses the hydration warning when using the card component in the carousel
   * as we do not know the users breakpoint when the component is rendered on the server.
   */
  , _objectSpread(_objectSpread({
    suppressHydrationWarning: true,
    className: classNames({
      'card-accent-bar': accentBar,
      'card-corner-size-large': cornerSize === 'lg'
    }, className),
    ref: ref,
    style: style
  }, rest), {}, {
    children: [accentBar && /*#__PURE__*/_jsx("div", {
      className: "accent-bar"
    }), children]
  }));
};

var customComponents = {
  /**
   * Custom components
   */
  Subtitle: Description,
  Text: Body,
  Title: Title,
  Media: function Media(_ref2) {
    var aspectRatio = _ref2.aspectRatio,
        objectFit = _ref2.objectFit,
        rest = _objectWithoutProperties(_ref2, _excluded2);

    return /*#__PURE__*/_jsx(_Media, _objectSpread({
      hideBorder: true,
      aspectRatio: aspectRatio,
      objectFit: objectFit || 'cover'
    }, rest));
  },
  TabIndicator: TabIndicator
};
var defaultComponents = {
  /**
   * Default react-bootstrap components
   */
  Img: Default.Img,
  Body: Default.Body,
  Link: Default.Link,
  Header: Default.Header,
  Footer: Default.Footer,
  ImgOverlay: Default.ImgOverlay
};

var _CardWithRef = /*#__PURE__*/forwardRef(_Card);

export var Card = Object.assign(_CardWithRef, customComponents, defaultComponents);